import React from 'react';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { react2panel } from 'common/util/react2panel';
export function CsvFormatInfo() {
  const {
    t
  } = useTranslation();
  return <Trans i18nKey={"settings.org-settings.invite-users.csv-format-info"} t={t} components={{
    ctaLink: <a href={"https://cdn.mxpnl.com/static/organizations/bulk_add_template.csv"} download={"bulk_adding_template.csv"} />
  }} data-sentry-element="Trans" data-sentry-component="CsvFormatInfo" data-sentry-source-file="csv-format-info.tsx" />;
}
export const CsvFormatInfoEl = react2panel("mp-invite-user-csv-format-info", CsvFormatInfo);